import { Link } from "react-router-dom";

// Stacked "performance card" illustration — Deep Slate / Emerald / Ice Blue palette.
// Inspired by Dribbble payment-method visuals, redrawn for SideB.

export const PaymentCardStack = ({ className = "" }) => (
  <div className={`relative ${className}`} data-testid="payment-card-stack">
    {/* Back card — ice blue */}
    <div
      className="absolute right-6 top-2 w-[280px] h-[176px] rounded-2xl shadow-2xl border border-black/5"
      style={{ background: "linear-gradient(135deg, #d6c5f0 0%, #b89ee6 100%)", transform: "rotate(-8deg)" }}
    >
      <div className="p-5 h-full flex flex-col justify-between">
        <div className="flex justify-between items-start">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-[#0b1e5a]/55 font-medium">Margin</div>
            <div className="text-[#0b1e5a] text-xl font-semibold mt-1">Optimized</div>
          </div>
          <div className="w-9 h-7 rounded bg-gradient-to-br from-[#F5C26B] to-[#9C7C2B]" />
        </div>
        <div>
          <div className="font-mono text-[#0b1e5a]/75 text-sm tracking-wider">•••• 2026</div>
          <div className="text-[10px] text-[#0b1e5a]/55 mt-1">Q1 Performance</div>
        </div>
      </div>
    </div>

    {/* Middle card — dark slate */}
    <div
      className="absolute right-2 top-8 w-[280px] h-[176px] rounded-2xl shadow-2xl border border-white/5"
      style={{ background: "linear-gradient(135deg, #273591 0%, #0b1e5a 100%)", transform: "rotate(-2deg)" }}
    >
      <div className="p-5 h-full flex flex-col justify-between">
        <div className="flex justify-between items-start">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-white/45 font-medium">Pipeline</div>
            <div className="text-white text-xl font-semibold mt-1">Diagnosed</div>
          </div>
          <div className="flex gap-1">
            <div className="w-5 h-5 rounded-full bg-[#ac62ea]" />
            <div className="w-5 h-5 rounded-full bg-[#d6c5f0] -ml-2" />
          </div>
        </div>
        <div>
          <div className="font-mono text-white/85 text-sm tracking-wider">VELOCITY · TUNED</div>
          <div className="text-[10px] text-white/45 mt-1">Quarterly review</div>
        </div>
      </div>
    </div>

    {/* Front card — emerald (brand) */}
    <div
      className="absolute right-0 top-16 w-[280px] h-[176px] rounded-2xl shadow-2xl border border-white/10"
      style={{ background: "linear-gradient(135deg, #ac62ea 0%, #6a36b3 100%)", transform: "rotate(5deg)" }}
    >
      <div className="p-5 h-full flex flex-col justify-between relative overflow-hidden">
        <div
          className="absolute -right-12 -top-12 w-44 h-44 rounded-full"
          style={{ background: "radial-gradient(circle, rgba(255,255,255,0.28) 0%, transparent 70%)" }}
        />
        <div className="flex justify-between items-start relative">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-white/85 font-medium">SideB · Studio</div>
            <div className="text-white text-xl font-semibold mt-1">Revenue OS</div>
          </div>
          <div className="w-9 h-7 rounded bg-white/30 backdrop-blur" />
        </div>
        <div className="relative">
          <div className="font-mono text-white text-sm tracking-wider">EXP 12/26</div>
          <div className="text-[10px] text-white/75 mt-1">Active engagement</div>
        </div>
      </div>
    </div>
  </div>
);

export const PayTile = ({ label, accent = "#ac62ea", glyph = "card", to }) => {
  const inner = (
    <>
      <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-4" style={{ background: accent + "26" }}>
        {glyph === "card" && (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={accent} strokeWidth="1.5">
            <rect x="2" y="6" width="20" height="14" rx="2" />
            <path d="M2 11h20" />
          </svg>
        )}
        {glyph === "wallet" && (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={accent} strokeWidth="1.5">
            <path d="M3 6a2 2 0 0 1 2-2h14v16H5a2 2 0 0 1-2-2V6z" />
            <path d="M16 12h3" />
          </svg>
        )}
        {glyph === "bolt" && (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={accent} strokeWidth="1.5">
            <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />
          </svg>
        )}
        {glyph === "shield" && (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={accent} strokeWidth="1.5">
            <path d="M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-4z" />
          </svg>
        )}
      </div>
      <div className="flex items-center justify-between">
        <div className="text-white text-sm font-medium">{label}</div>
        {to && <span className="text-white/50 text-xs">→</span>}
      </div>
    </>
  );
  if (to) {
    return (
      <Link to={to} className="card-ink p-5 w-full block hover:border-white/20 transition-colors" data-testid={`pay-tile-${label}`}>{inner}</Link>
    );
  }
  return <div className="card-ink p-5 w-full" data-testid={`pay-tile-${label}`}>{inner}</div>;
};

export default PaymentCardStack;
